export const redirectUrl = process.env.REACT_APP_DOMAIN
export const project     = process.env.REACT_APP_PROJECT.toUpperCase()
export const VK_ID       = process.env.REACT_APP_VK_ID
export const vkOauthUrl  = `https://oauth.vk.com/authorize?client_id=${VK_ID}&display=popup&redirect_uri=${redirectUrl}`
